import React from 'react'
import Page from '../components/Page'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Alert, Form, FormFeedback, FormGroup, FormText, Input, Table, InputGroup, InputGroupAddon, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import Typography from '../components/Typography'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import moment from 'moment-timezone'
import { getColor } from '../utils/colors'
import { MdRemoveCircle, MdAddCircle, MdCancel, MdShoppingCart, MdDelete } from 'react-icons/md'

class PosOrderReorderPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      order_id: this.props.match.params.order_id,
      store_id: this.props.match.params.id,
      order: null,
      all_products: [],
      visible_products: [],
      categoryList: [],
      selectedProduct: [],
      filter: [],
      store: null,
      unit: 0,
      subtotal: 0,
      total_payable: 0,
      total_tax: 0,
      total_discount: 0,
      total_outstanding: 0,
      total_rounding: 0,
      subtotal: 0,
      promo_code: '',
      redeemSuccess: false,
      store_tax_list: [],
      redeem: [],
      payment_status: 'Pending Payment',
      isReady: false,
      final_items: [],
      shipping: [],
      enable_silo: false,
      missing_items: [],
    }
  }

  componentDidMount() {
    this.getOrderDetail()
    this.getStoreDetail()
    this.getStoreTax()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  randStr(strlength) {
    let rand = ''
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let charactersLength = characters.length
    for (var i = 0; i < strlength; i++) {
      rand += characters.charAt(Math.floor(Math.random() * charactersLength))
    }

    return rand.toUpperCase()
  }

  financial(x) {
    let twodn = Math.round((Number.parseFloat(x) + Number.EPSILON) * 100) / 100
    return twodn.toFixed(2)
  }

  checkPriceMod(product, quantity) {
    let price = JSON.parse(product.price_data)[0].price
    if (product.price_mod.length) {
      for (let pm of product.price_mod) {
        if (quantity >= pm.min_qty && quantity <= pm.max_qty) {
          price = JSON.parse(pm.price_data)[0].price
        }
      }
    }
    return price
  }

  checkExceedMaxQty(product, quantity, include_cart) {
    let cart = this.state.selectedProduct

    let cart_item = []
    if (cart) {
      cart_item = cart.filter(el => el.id == product.id && el.store_id == product.store_id)
    }

    let cart_item_qty = 0

    for (let c of cart_item) {
      cart_item_qty += c.quantity
    }

    let qty = parseInt(quantity)
    if (include_cart) {
      qty += parseInt(cart_item_qty)
    }

    if (product.product_condition.length > 0) {
      let now_date = moment().format('YYYY-MM-DD')
      for (let i of product.product_condition) {
        if (i.condition_type === 'MaxQuantity') {
          let start_date = moment(i.start_date).format('YYYY-MM-DD')
          let end_date = moment(i.end_date).format('YYYY-MM-DD')
          if (now_date >= start_date && now_date <= end_date) {
            if (qty > parseInt(i.params)) {
              let str = ''
              if (cart_item_qty > 0) {
                str += 'You have ' + cart_item_qty + ' in your cart. '
              }
              return str + 'You are allowed to purchase maximum ' + i.params + ' per order for this item'
            }
          }
        }
      }
    }
    return ''
  }

  checkCart(product, added_qty, include_cart) {
    let cart = this.state.selectedProduct
    let available_stock = JSON.parse(product.qty_data)[0].qty
    let ignore_stock = product.ignore_stock

    let cart_item = []
    if (cart) {
      cart_item = cart.filter(el => el.id == product.id && el.store_id == product.store_id)
    }

    let cart_item_qty = 0

    for (let c of cart_item) {
      cart_item_qty += c.quantity
    }

    let total_added_quantity = parseInt(added_qty)
    if (include_cart) {
      total_added_quantity += parseInt(cart_item_qty)
    }

    if (ignore_stock < 1) {
      if (total_added_quantity > available_stock) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  addToCart = () => {
    const { selectedProduct } = this.state
    let newArr = []

    if (selectedProduct.length == 0) {
      return
    }

    for (let obj of selectedProduct) {
      let product_data = this.state.visible_products.find(el => el.id == obj.product_id)
      if (product_data) {
        const product = product_data
        const added_quantity = parseInt(obj.qty)
        if (added_quantity > 0) {
          let limitReached = this.checkCart(product, added_quantity, false)
          if (limitReached) {
            alert(obj.name + ': Quantity exceed order limit.')
            return
          }

          let maxQuantityReached = this.checkExceedMaxQty(product, added_quantity, false)
          if (maxQuantityReached) {
            alert(maxQuantityReached)
            return
          }

          let quantity = parseInt(added_quantity)
          let cartitem_id = this.randStr(20)
          let available_dates = []

          let d_start = ''
          let d_end = ''

          if (product.product_condition.length) {
            for (let i of product.product_condition) {
              if (i.condition_type === 'Available') {
                available_dates.push({
                  start_date: i.start_date,
                  end_date: i.end_date,
                })

                d_start = i.start_date
                d_end = i.end_date
              }
            }
          }

          newArr.push({
            cartitem_id: cartitem_id,
            store_id: product.store_id,
            store_code: this.state.store.store_code,
            id: parseInt(product.id),
            product_no: product.product_no,
            unit: JSON.parse(product.price_data)[0].unit,
            custom_product: product.custom_product ? product.custom_product : null,
            product_type: product.product_type,
            name: product.name,
            chn_name: product.chn_name,
            image: product.image,
            quantity: quantity,
            price: this.checkPriceMod(product, quantity),
            available_dates: available_dates,
            d_start: d_start,
            d_end: d_end,
            type: 'main',
            addOn: '',
            weight: 1,
            fixed_price: false,
          })
        }
      } else {
        // alert(obj.product_no + ' no longer available in your menu');
      }
    }

    if (newArr.length > 0) {
      this.setState({ final_items: newArr, isReady: true }, () => this.countPrice())
    } else {
      alert('Invalid quantity. Please enter correct number')
    }
  }

  cleartCart = () => {
    if (window.confirm('Clear all items? This action cannot be undone.')) {
      this.setState({ selectedProduct: [] })
    }
  }

  onDown = (id, quantity) => {
    const { selectedProduct } = this.state
    let products = [...selectedProduct]
    let index = products.findIndex(obj => obj.product_id == id)
    let item = products.find(obj => obj.product_id == id)

    if (index > -1 && item) {
      if (quantity > 0) {
        item.qty = quantity - 1
      }
    }

    this.setState({ selectedProduct: products })
  }

  onUp = (i, quantity) => {
    if (quantity) {
      quantity = parseInt(quantity)
    }

    const { selectedProduct } = this.state
    let products = [...selectedProduct]
    let index = products.findIndex(obj => obj.product_id == i.id)
    let item = products.find(obj => obj.product_id == i.id)

    if (this.checkStock(i, (quantity += 1))) {
      if (index > -1 && item) {
        item.qty = quantity
      } else {
        products.push({
          product_id: parseInt(i.id),
          name: i.name,
          chn_name: i.chn_name,
          price: parseFloat(JSON.parse(i.price_data)[0].price),
          qty: 1,
          data: i,
        })
      }
      this.setState({ selectedProduct: products })
    }
  }

  changeQuantityHandler = (i, event) => {
    let data = event.target.value

    if (isNaN(data)) {
      data = ''
    } else {
      data = data >= 0 ? data : 0
    }

    if (data) {
      data = parseInt(event.target.value)
    }
    const { selectedProduct } = this.state
    let products = [...selectedProduct]
    let index = products.findIndex(obj => obj.product_id == i.id)
    let item = products.find(obj => obj.product_id == i.id)
    if (this.checkStock(i, data)) {
      if (index > -1 && item) {
        item.qty = data
      } else {
        products.push({
          product_id: parseInt(i.id),
          name: i.name,
          chn_name: i.chn_name,
          price: parseFloat(JSON.parse(i.price_data)[0].price),
          qty: data,
          data: i,
        })
      }

      this.setState({ selectedProduct: products })
    }
  }

  checkStock(i, quantity) {
    let product = i

    let available_stock = JSON.parse(product.qty_data)[0].qty
    let ignore_stock = product.ignore_stock
    let product_condition = product.product_condition

    let qty = parseInt(quantity)

    if (ignore_stock < 1) {
      if (qty > available_stock) {
        alert(i.name + ': Quantity exceed order limit.')
        return false
      }
    }

    if (product_condition.length > 0) {
      let now_date = moment().format('YYYY-MM-DD')
      for (let i of product_condition) {
        if (i.condition_type === 'MaxQuantity') {
          let start_date = moment(i.start_date).format('YYYY-MM-DD')
          let end_date = moment(i.end_date).format('YYYY-MM-DD')
          if (now_date >= start_date && now_date <= end_date) {
            if (qty > parseInt(i.params)) {
              alert('You are allowed to purchase maximum ' + i.params + ' per order for this item')
              return false
            }
          }
        }
      }
    }

    return true
  }
  //checkout start

  // redeem = () => {
  //   const url = process.env.REACT_APP_UNITY_API2_URL;
  //   const comp = StorageService.getSession('selected_org')
  //   const user = StorageService.getSession('user_info')

  //   const formData = {
  //     session_key: user.session_key,
  //     company_id: comp.CompanyID,
  //     store_code: this.state.store.store_code,
  //     promo_code: this.state.promo_code,
  //   };
  //   axios
  //     .post(url + ':3030/v2/cart/customer/voucher/redeem', formData)
  //     .then(response => {
  //       const result = response.data;
  //       if (result.error == true && result.message != 'Success') {
  //         alert(result.message);
  //         return;
  //       }
  //       if (result.data) {
  //         alert('Redemption was successful');
  //         this.setState({
  //           redeem: result.data,
  //           redeemSuccess: true,
  //         });

  //         this.countPrice();
  //       } else {
  //         alert(result.message);
  //         this.setState({
  //           promo_code: ''
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       alert(error)
  //     });
  // };

  calculateTax(price, tax) {
    let p = price
    let t = tax
    let result = 0
    if (tax.inclusive === 1) {
      //inclusive
      let val = 100 + t.rate
      result = (p / val) * t.rate
    } else {
      result = (p / 100) * t.rate
    }
    return this.financial(result)
  }

  // calculateDiscount(redeem, item_total) {
  //   let discount = 0;
  //   if(redeem.length && redeem[0].promo_type === 'DISCOUNT') {
  //     let valid = this.isValidDiscount(redeem[0].compare_type, parseFloat(redeem[0].compare_value), item_total);
  //     if(valid) {
  //       if(redeem[0].options === 'PERCENT') {
  //         discount = (item_total * Number(redeem[0].mod_value)) / 100;
  //       } else {
  //         discount = Number(redeem[0].mod_value);
  //       }
  //     }
  //   }
  //   this.setState({ discount });
  //   return discount;
  // }

  // isValidDiscount(condition, compare_value, item_total) {
  //   let valid = false;

  //   if(condition === 'MORETHAN') {
  //     valid = item_total > compare_value ? true : false;
  //   } else if (condition === 'LESSTHAN') {
  //     valid = item_total < compare_value ? true : false;
  //   } else if (condition === 'EQUAL') {
  //     valid = item_total == compare_value ? true : false;
  //   } else {
  //     valid = true;
  //   }

  //   return valid;
  // }

  countPrice = () => {
    const { final_items, store_tax_list } = this.state
    let total_unit = 0
    let total_price = 0
    let total_price_no_nett_price = 0
    let total_payable = 0

    //count item price
    for (let i of final_items) {
      if (i.type === 'main') {
        total_price += i.price * i.weight * i.quantity
        total_unit += i.quantity

        if (i.nett_price < 1) {
          total_price_no_nett_price += i.price * i.weight * i.quantity
        }
      } else {
        total_price += parseFloat(i.price * i.weight * (i.quantity * final_items.find(el => el.cartitem_id === i.cartitem_id && el.type === 'main').quantity))
        total_price_no_nett_price += parseFloat(i.price * i.weight * (i.quantity * final_items.find(el => el.cartitem_id === i.cartitem_id && el.type === 'main').quantity))
      }
    }

    //count discount
    let total_discount = parseFloat(this.state.total_discount)
    total_payable = total_price - total_discount

    //count shipping
    for (let s of this.state.shipping) {
      total_payable += parseFloat(s.price)
    }

    //count tax
    let total_tax = 0
    let total_exclusive_tax = 0
    let taxes = []
    if (store_tax_list.length > 0) {
      for (let t of store_tax_list) {
        let tax_amount = 0
        tax_amount = this.calculateTax(total_payable, t)
        total_tax += parseFloat(tax_amount)

        if (t.inclusive === 0) {
          //exclusive, add to total payable
          total_exclusive_tax += parseFloat(tax_amount)
        }

        taxes.push({
          tax_id: this.randStr(20),
          tax_type_id: t.id,
          name: t.name,
          rate: t.rate,
          amount: tax_amount,
        })
      }
    }

    total_payable += total_exclusive_tax

    //rounding
    let total_rounding = 0
    if (this.state.store.rounding === 1) {
      total_rounding = Number(total_payable.toString()[3]) / 100
      total_payable = parseInt('' + total_payable * 10) / 10
    }

    let total_outstanding = Math.abs(Number(this.state.order.total_paid) - total_payable)
    let payment_status = total_outstanding > 0 ? 'Pending Payment' : 'Paid'

    this.setState({ taxes, total_tax, total_payable, total_discount, total_outstanding, payment_status, total_rounding, subtotal: total_price, unit: total_unit })
  }

  submitOrder = () => {
    const { final_items, taxes, order } = this.state
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    if (window.confirm('Update your order? This action cannot be undone.')) {
      document.getElementById('placeOrderBtn').setAttribute('disabled', '')
      if (final_items.length < 1) {
        alert('No item to checkout.')
        document.getElementById('placeOrderBtn').removeAttribute('disabled')
        return
      }

      if (!user) {
        alert('Session expired. Please login to continue.')
        document.getElementById('placeOrderBtn').removeAttribute('disabled')
        return
      }

      if (!order) {
        alert('Something wrong when looking for your order. Please reload and try again.')
        document.getElementById('placeOrderBtn').removeAttribute('disabled')
        return
      }

      let cart_items = []
      let main_count = 0
      let sub_count = 1

      for (let i of final_items) {
        let item_total_price = this.financial(Number(i.price) * i.weight * i.quantity)
        let item_total_quantity = i.quantity
        let item_type = i.product_type
        let item_parent = ''
        let item_unit = i.unit
        let item_id = this.randStr(20) //#01

        if (i.type === 'main' && i.product_type === 'set') {
          main_count++
        }

        if (i.type === 'main' && i.product_type === 'combo') {
          main_count++
        }

        let main_count_str = ''
        main_count_str = main_count < 10 ? '0' + main_count : main_count.toString()

        if (i.type === 'sub') {
          let main_item_qty = 0
          let main_item = final_items.find(el => el.cartitem_id === i.cartitem_id && el.type === 'main')
          main_item_qty = main_item.quantity
          item_total_price = this.financial(Number(i.price) * i.weight * (i.quantity * main_item_qty))
          item_total_quantity = i.quantity * main_item_qty
          item_type = main_item.name
          item_parent = JSON.stringify([{ name: 'Set', data: '#' + main_count_str, options: sub_count }])
          sub_count++
        }

        if (i.type === 'main' && i.product_type === 'set') {
          item_parent = JSON.stringify([{ name: 'Set', data: '#' + main_count_str, options: null }])
        }

        if (i.type === 'main' && i.product_type === 'combo') {
          item_parent = JSON.stringify([{ name: 'Set', data: '#' + main_count_str, options: null }])
        }

        if (i.product_type === 'weight') {
          item_unit = i.weight + 'g'
        }

        cart_items.push({
          cartitem_id: item_id,
          store_id: i.store_id,
          product_id: i.id,
          product_no: i.product_no,
          name: i.name,
          unit: item_unit,
          reference: null,
          data: item_parent,
          custom_data: null,
          service_report: null,
          custom_product: i.custom_product,
          qty: item_total_quantity,
          price: '$' + item_total_price,
          discount: '$0.00',
          product_type: item_type,
        })
      }

      if (taxes.length > 0) {
        for (let t of taxes) {
          t.amount = this.financial(t.amount)
        }
      }

      if (this.state.shipping.length > 0) {
        for (let sf of this.state.shipping) {
          cart_items.push({
            cartitem_id: this.randStr(20),
            store_id: this.state.store_id,
            product_id: 0,
            product_no: sf.product_no,
            name: sf.name,
            unit: 'service',
            reference: null,
            data: '',
            custom_data: null,
            service_report: null,
            custom_product: null,
            qty: 1,
            price: '$' + this.financial(Number(sf.price)),
            discount: '$0.00',
            product_type: 'service',
          })
        }
      }

      const formData = {
        // session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        session_key: user.unity_session_key,
        // user_session_key: user.session_key,
        store_id: this.state.store_id,
        order_id: this.state.order_id,
        company_id: comp.CompanyID,
        order_type: order.order_type,
        service_type: order.service_type,
        total_price: this.financial(this.state.total_payable),
        total_rounding: this.financial(this.state.total_rounding),
        total_paid: order.total_paid,
        total_outstanding: this.financial(this.state.total_outstanding),
        total_discount: this.financial(this.state.total_discount),
        total_tax: this.financial(this.state.total_tax),
        remark: order.remark,
        itemcount: this.state.unit,
        order_status: order.order_status,
        payment_status: this.state.payment_status,
        // voucher_code: this.state.redeem.length ? this.state.redeem[0].voucher_code : '',
        items: cart_items,
        payment_items: [],
        tax_items: taxes,
        schedule: order.schedule,
        address: order.address,
        billing: order.billing,
      }

      axios
        .post(url + ':3003/v1/order/create', formData)
        .then(response => {
          const result = response.data
          document.getElementById('placeOrderBtn').removeAttribute('disabled')
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }

          if (result.error == false && result.message == 'Success') {
            alert('Order has been updated successfully.')
            this.props.history.replace(`/posorder/store/${this.state.store_id}/${this.state.order_id}`)
          } else {
            alert(result.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    }
    //calculate subtotal, tax, shipping, total payable
  }

  //checkout end

  getStoreTax() {
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3001/v1/store/tax', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            store_tax_list: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreProduct() {
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const { selectedProduct } = this.state
    if (!this.state.order.customer) {
      alert('Missing customer ID. Please confirm customer data exists in this order')
      return
    }
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.order.customer.customer_id,
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3003/v1/order/silo/products', data)
      .then(response => {
        const result = response.data

        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let visible_products = []
          let missing_products = []
          // let order_items = [];
          if (result.data.length > 0) {
            visible_products = result.data.filter(el => el.default_list == 1 && (el.product_type == 'unit' || el.product_type == 'service' || el.product_type == 'contract' || el.product_type == 'single'))
          }

          for (let obj of selectedProduct) {
            let found = visible_products.find(el => el.id == obj.product_id)
            if (found) {
              // order_items.push(obj)
            } else {
              missing_products.push(obj)
            }
          }
          this.setState({ all_products: visible_products, visible_products, missing_items: missing_products })

          // this.setState({ all_products: visible_products, visible_products, selectedProduct: order_items, missing_items: missing_products});
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreDetail() {
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3001/v1/store/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            store: result.data,
            enable_silo: result.data.enable_silo > 0 ? true : false,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderDetail() {
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }

    axios
      .post(url + ':3003/v1/order/detail', data)
      .then(response => {
        const result = response.data
        let objData = null
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          objData = result.data
          let products = []
          let shipping = []
          if (objData) {
            for (let i of objData.items) {
              let price = i.price.slice(1)
              price = Number(price) / i.qty
              i.price = price

              if (i.product_id > 0) {
                products.push(i)
              } else {
                shipping.push(i)
              }
            }
          }
          this.setState({ order: objData, selectedProduct: products, shipping: shipping, total_outstanding: objData.total_outstanding, total_payable: objData.total_price, total_tax: objData.total_tax, total_discount: objData.total_discount, unit: objData.itemcount }, () => {
            this.getStoreProduct()
          })
        }
      })
      //   .then(() => {

      //   })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    const { collapse, selectedProduct, filter, isLoading } = this.state
    let path = [
      {
        name: 'Store',
        active: false,
        path: '/posorder',
      },
      {
        name: 'Order',
        active: false,
        path: '/posorder/store/' + this.state.store_id,
      },
      { name: 'Detail', active: false, path: '/posorder/store/' + this.state.store_id + '/' + this.state.order_id },
      { name: 'Reorder', active: true, path: '' },
    ]
    if (this.props.history.location.state && this.props.history.location.state.prevPath == '/posreport') {
      path = [{ name: 'Report', active: false, path: '/posreport' }, , { name: 'Detail', active: true, path: '' }]
    }

    return (
      <Page title={`Reorder ${this.state.order_id}`} breadcrumbs={path} id="reorderPage">
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Card className="ps-card-display">
          <CardHeader className="ps-bg-gradient">Order Summary</CardHeader>
          <CardBody>
            <Alert color="info">
              <Typography type="h5" className="alert-heading">
                {this.state.store?.name} {this.state.store?.store_code && `(${this.state.store.store_code})`}
              </Typography>
              {this.state.store?.location} {this.state.store?.store_type && `(${this.state.store.store_type})`}
            </Alert>
            {this.state.order && (
              <React.Fragment>
                <p className="text-danger">
                  <strong>Price will change after clicking "Update order". Lastly, to confirm changes, please click "Confirm reorder".</strong>
                </p>
                <Row form>
                  <Col lg={2}>
                    <Label>Units</Label>
                    <p>{this.state.unit}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Subtotal($)</Label>
                    <p>{this.financial(this.state.subtotal)}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Total Tax($)</Label>
                    <p>{this.financial(this.state.total_tax)}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Total Outstanding($)</Label>
                    <p>{this.financial(this.state.total_outstanding)}</p>
                  </Col>
                  <Col lg={3}>
                    {/* <Label>Promo Code</Label>
                                <InputGroup>
                                  <Input placeholder="Enter promo code" name="promo_code" value={this.state.promo_code} onChange={this.changeHandler} disabled={this.state.redeemSuccess}/>
                                  <InputGroupAddon addonType="append">
                                    <Button style={{fontSize: '0.85rem'}} type="button" onClick={() =>this.redeem()} disabled={this.state.redeemSuccess ? true: selectedProduct.length > 0 ? false : true}>Use Code</Button>
                                  </InputGroupAddon>
                                </InputGroup> */}
                    <Label>Total Discount($)</Label>
                    <p>{this.financial(this.state.total_discount)}</p>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </CardBody>
        </Card>
        <br />
        {this.state.visible_products.length > 0 && (
          <Row>
            <Col lg={3} md={12}>
              <Button className="theme-button theme-button-dark" type="button" block onClick={() => this.cleartCart()}>
                <MdDelete /> Clear All Item ({selectedProduct.filter(el => el.qty > 0).length})
              </Button>
            </Col>
            <Col lg={this.state.isReady ? 4 : 9} md={12}>
              {this.state.isReady && (
                <Button color="danger" type="button" block onClick={() => this.setState({ isReady: false })}>
                  Back
                </Button>
              )}
              {!this.state.isReady && (
                <Button className="theme-button theme-button-secondary" type="button" block onClick={() => this.addToCart()}>
                  Update order
                </Button>
              )}
            </Col>
            {this.state.isReady && (
              <Col lg={5} md={12}>
                <Button className="theme-button theme-button-secondary" type="button" block onClick={() => this.submitOrder()} id="placeOrderBtn">
                  Confirm reorder
                </Button>
              </Col>
            )}
          </Row>
        )}
        <br />
        {this.state.missing_items.length > 0 && (
          <Alert color="danger">
            <Typography type="h5" className="alert-heading">
              Missing Items
            </Typography>
            <div style={{ fontSize: '0.85rem' }}>
              You've ordered items below. However, items listed here no longer available in your menu. It will be removed from this order once reorder is confirmed.
              <br />
              <br />
              <ol>
                {this.state.missing_items.map((i, index) => {
                  return (
                    <li key={index}>
                      {i.product_no}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{i.name} x {i.qty} &nbsp;&nbsp;&nbsp; ${this.financial(i.price * i.qty)}
                    </li>
                  )
                })}
              </ol>
            </div>
          </Alert>
        )}

        <Card>
          <table className="d-md-table ps-list cart mb-1">
            <thead className="ps-bg-gradient">
              <tr>
                <th style={{ textAlign: 'left' }}>Code</th>
                <th style={{ textAlign: 'left' }}>Item</th>
                <th>Unit Price</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {this.state.visible_products.length > 0 &&
                this.state.visible_products.map((i, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.product_no}</div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</div>
                        </div>
                      </td>

                      <td>
                        <div style={{ textAlign: 'center', color: getColor('primary') }}>${parseFloat(JSON.parse(i.price_data)[0].price).toFixed(2)}</div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center my-3">
                          <MdRemoveCircle style={buttonIconStyle} onClick={() => this.onDown(i.id, selectedProduct.find(o => o.product_id == i.id) ? selectedProduct.find(o => o.product_id == i.id).qty : 0)} />
                          <Input
                            style={{ backgroundColor: selectedProduct.find(o => o.product_id == i.id) && selectedProduct.find(o => o.product_id == i.id).qty > 0 ? '#DAF7A6' : '#ffffff', ...quantityInputStyle }}
                            type="number"
                            min="0"
                            value={selectedProduct.find(o => o.product_id == i.id) ? selectedProduct.find(o => o.product_id == i.id).qty : 0}
                            onChange={this.changeQuantityHandler.bind(this, i)}
                          />
                          <MdAddCircle style={buttonIconStyle} onClick={() => this.onUp(i, selectedProduct.find(o => o.product_id == i.id) ? selectedProduct.find(o => o.product_id == i.id).qty : 0)} />
                        </div>
                      </td>
                      <td>
                        <div style={{ textAlign: 'center', color: getColor('primary') }}>${parseFloat(selectedProduct.find(o => o.product_id == i.id) ? selectedProduct.find(o => o.product_id == i.id).qty * selectedProduct.find(o => o.product_id == i.id).price : 0).toFixed(2)}</div>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </Card>
      </Page>
    )
  }
}

export default PosOrderReorderPage

const buttonIconStyle = {
  fontSize: '30px',
  color: getColor('primary'),
  margin: 'auto 3px',
}

const quantityInputStyle = {
  maxWidth: '60px',
  textAlign: 'center',
}
